export function gotoDashboard() {
  window.location.href = '/dashboard'
}

export function gotoTickets() {
  window.location.href = '/dashboard/tickets'
}

export function gotoSignOut(redirectTo) {
  window.location.href = `/sign-out?redirectTo=${redirectTo}`
}

export function gotoSignIn(redirectTo) {
  window.location.href = `/sign-in?redirectTo=${redirectTo}`
}

export function gotoHomepage() {
  window.location.href = '/'
}

export function gotoEventManager(eventSlug, page) {
  window.location.href = `${BASE_URL}${page !== 'promote' ? '/host' : ''}/events/${eventSlug}/${page}`
}

export function gotoTagSearch(tagSlug) {
  window.location.href = `${BASE_URL}/explore?query=${tagSlug}`
}

export function gotoDiscover() {
  window.location.href = '/explore'
}

export const signInPath = () => (
  SSR_DATA.prerendering ? '/sign-in' : `/sign-in?redirectTo=${window.location.href}`
)
